import React, { Fragment, useEffect, useState } from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { Tabs, Tab } from "@mui/material";
import { Card, Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import { toast } from "react-toastify";
import { isEmpty } from "lodash";
import {
  createNewSlider,
  fetchSliderById,
  updateSlider,
} from "../actions/slider";
import SubmitButtonForm from "../components/Admin/Reusable/Form/SubmitButtonForm";
import FormTitleMain from "../components/Admin/Reusable/FormTitleMain";
import InputField from "../components/Admin/Reusable/InputField";
import UploadImage from "../components/Admin/Reusable/UploadImage";
import languagesItems from "../utils/languages";

import { TabPanel, a11yProps } from "../helper/TabPanel";
import SelectStatus from "../components/Admin/Reusable/Form/SelectStatus";

import { useSelector } from "react-redux";
import { basicFormValidationHandler, validateLocalesFields } from "../utils";
import { appendIfFile } from "../helper/FileCheck";
import { sliderActions } from "../reducers/slider";
import GlobalProgressOverlay from "../components/Admin/Reusable/GlobalProgressOverlay";

const SliderAdd = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { id } = useParams();

  const [activeLocaleTab, setActiveLocaleTab] = useState(0);
  const handleChangeLocaleTab = (e, newValue) => setActiveLocaleTab(newValue);
  const [errors, setErrors] = useState({});
  const { sliderDetail, loading, success } = useSelector(
    (state) => state.sliderReducer
  );
  //locales
  // const [locales, setLocales] = useState(() =>
  //   Object.fromEntries(
  //     languagesItems.map((l) => [
  //       l.code,
  //       {
  //         id: null,
  //         title: "",
  //         subtitle: "",
  //         description: "",
  //         language: l.code,
  //       },
  //     ])
  //   )
  // );
  const getInitialLocales = () =>
    Object.fromEntries(
      languagesItems.map((l) => [
        l.code,
        {
          id: null,
          title: "",
          subtitle: "",
          button: "",
          description: "",
          language: l.code,
        },
      ])
    );

  const [locales, setLocales] = useState(getInitialLocales);

  const initialState = {
    link: "",
    video: "",
    active: true,
    position: "",
    sectionType: "HOME",
    // videoPlayerId: "",
    videoTargetId: "",
  };

  //osnovi podaci
  const [data, setData] = useState(initialState);

  // const initialStateFiles = {
  //   banner: null,
  //   mobileBanner: null,
  // };

  // //fajlovi
  // const [files, setFiles] = useState(initialStateFiles);
  const [progress, setProgress] = useState(0);
  const [showLoader, setShowLoader] = useState(false);

  //breadcrumbs
  const translateForm = "sliderForm";
  const translateModule = "slider";
  const pageType = id ? "Edit" : "Add";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  // const setFile = (key) => (file) =>
  //   setFiles((prev) => ({ ...prev, [key]: file }));

  useEffect(() => {
    if (!id) {
      // Ako `id` ne postoji, očisti stanje za novu kreaciju
      setData(initialState);
      // setFiles(initialStateFiles);
      setLocales(getInitialLocales());
    } else {
      // Ako `id` postoji, učitaj podatke za korisnika
      dispatch(fetchSliderById(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (sliderDetail && id) {
      setData({
        ...sliderDetail,
      });
      // setFiles({
      //   banner: sliderDetail?.banner,
      //   mobileBanner: sliderDetail?.mobileBanner,
      // });

      // popuni locales iz backend-a
      const filledLocales = Object.fromEntries(
        languagesItems.map((l) => {
          const found = sliderDetail.locales?.find(
            (loc) =>
              loc.language === l.code || loc.language === l.label.toUpperCase()
          );
          return [
            l.code,
            {
              id: found?.id || null,
              title: found?.title || "",
              subtitle: found?.subtitle || "",
              button: found?.button || "",
              description: found?.description || "",
              language: l.code,
            },
          ];
        })
      );

      setLocales(filledLocales);
    }
  }, [sliderDetail, id, dispatch]);

  const userValidationHandler = () => {
    const { videoTargetId, link } = data;

    let errorsObject = {};
    errorsObject = basicFormValidationHandler({
      videoTargetId,
    });

    // const localeErrors = validateLocalesFields(locales, ["title", "subtitle"]);
    // if (Object.keys(localeErrors).length > 0) {
    //   errorsObject.locales = localeErrors;
    // }

    setErrors(errorsObject);
    if (!isEmpty(errorsObject))
      toast.error("Morate popuniti sva obavezna polja!", {
        theme: "colored",
      });
    return !isEmpty(errorsObject);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (userValidationHandler()) {
      return;
    }

    const formData = new FormData();
    // pretvaranje locales objekta u niz za backend
    const localesArray = Object.entries(locales).map(([code, v]) => ({
      ...v,
      // ako postoji id, prosledi; ako ne, backend može generisati
      id: v.id || undefined,
    }));

    const dataForm = {
      ...data,
      locales: localesArray,
    };

    if (id) {
      dataForm.id = id;
    }

    // formData.append(
    //   "slider",
    //   new Blob([JSON.stringify(dataForm)], { type: "application/json" })
    // );
    // appendIfFile(formData, "banner", files.banner);
    // appendIfFile(formData, "mobileBanner", files.mobileBanner);

    if (id) {
      dispatch(updateSlider(dataForm, navigate, id));
    } else {
      dispatch(createNewSlider(dataForm, navigate));
    }
  };

  const updateLocale = (code, field, value) => {
    setLocales((prev) => ({
      ...prev,
      [code]: { ...prev[code], [field]: value },
    }));
  };

  const handleInputChange = (eOrName, maybeValue) => {
    if (typeof eOrName === "string") {
      const name = eOrName;
      const value = maybeValue;
      setData((prev) => ({ ...prev, [name]: value }));
      return;
    }

    const e = eOrName;
    const { name, type, value, checked } = e.target;

    setData((prev) => {
      // default ažuriranje
      let next = { ...prev, [name]: type === "checkbox" ? checked : value };

      return next;
    });
  };

  useEffect(() => {
    let interval;
    let timeout;

    if (loading) {
      setShowLoader(true);
      setProgress(0);

      interval = setInterval(() => {
        setProgress((prev) => {
          if (prev >= 100) {
            clearInterval(interval);
            return 100;
          }
          return prev + 5; // brzina punjenja (možeš promeniti)
        });
      }, 100);
    } else if (!loading && showLoader) {
      // kada loading prestane, dovrši do 100 ako nije stigao
      setProgress(100);
      // zadrži loader još 2 sekunde
      timeout = setTimeout(() => {
        setShowLoader(false);
        setProgress(0);
      }, 2000);
    }

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [loading]);

  useEffect(() => {
    if (success) {
      // ostavi loader još 2 sekunde pre redirekcije
      const timeout = setTimeout(() => {
        navigate("/slider-list");
        toast.success("Uspešno ste kreirali novi kanal", { theme: "colored" });
        dispatch(sliderActions.clearError());
      }, 2000);
      return () => clearTimeout(timeout);
    } else {
      dispatch(sliderActions.clearError());
    }
  }, [success]);

  return (
    <Fragment>
      <Breadcrumb
        breadcrumbItems={breadcrumbItems}
        type={`${translateModule}${pageType}`}
        id={id}
        pageType={pageType}
      />
      {showLoader && <GlobalProgressOverlay progress={progress} />}
      <Container className="slider-container">
        <Row>
          <Col lg={12}>
            <form onSubmit={handleSubmit} noValidate>
              <Row>
                <Col lg={12}>
                  <div className="text-end mb-2">
                    <SubmitButtonForm id={id} />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg={9}>
                  <Row>
                    <Col lg={12}>
                      <Card>
                        <Card.Header>
                          <FormTitleMain />
                        </Card.Header>
                        <Card.Body>
                          <div className="blog-holder-admin-left-side-text">
                            <Row>
                              <Col lg={5} md={12} xs={12} className="mb-4">
                                <InputField
                                  label={t(`${translateForm}.link`)}
                                  name="link"
                                  value={data.link}
                                  onChange={handleInputChange}
                                  error={errors}
                                  errorsHandler={setErrors}
                                  fullWidth
                                  size="small"
                                />
                              </Col>
                              <Col lg={4} md={12} xs={12} className="mb-4">
                                <InputField
                                  label={t(`${translateForm}.videoTargetId`)}
                                  name="videoTargetId"
                                  value={data.videoTargetId}
                                  onChange={handleInputChange}
                                  error={errors}
                                  errorsHandler={setErrors}
                                  fullWidth
                                  size="small"
                                  required
                                />
                              </Col>
                              {/* <Col lg={4} md={12} xs={12} className="mb-4">
                                <InputField
                                  label={t(`${translateForm}.videoPlayerId`)}
                                  name="videoPlayerId"
                                  value={data.videoPlayerId}
                                  onChange={handleInputChange}
                                  error={errors}
                                  errorsHandler={setErrors}
                                  fullWidth
                                  size="small"
                                  required
                                />
                              </Col> */}
                              <Col lg={3} md={12} xs={12} className="mb-4">
                                <InputField
                                  label={t(`${translateForm}.position`)}
                                  name="position"
                                  value={data.position}
                                  error={errors}
                                  errorsHandler={setErrors}
                                  fullWidth
                                  size="small"
                                  onChange={(e) => {
                                    const value = e.target.value;

                                    // Dozvoli samo cifre i max 6 karaktera
                                    if (
                                      /^\d*$/.test(value) &&
                                      value.length <= 6
                                    ) {
                                      // Ako je vrednost veća od 0 — prosledi je
                                      if (Number(value) > 0 || value === "") {
                                        handleInputChange(e);
                                      }
                                    }
                                  }}
                                  inputProps={{
                                    inputMode: "numeric",
                                    pattern: "[0-9]*",
                                  }}
                                />
                              </Col>
                              <Col lg={4} md={12} xs={12} className="mb-4">
                                <FormControl fullWidth required>
                                  <InputLabel id="demo-simple-select-label">
                                    {t(`${translateForm}.sectionType`)}
                                  </InputLabel>
                                  <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={data.sectionType}
                                    label={t(`${translateForm}.sectionType`)}
                                    name="sectionType"
                                    onChange={handleInputChange}
                                    size="small"
                                  >
                                    <MenuItem value="HOME">
                                      Početna strana
                                    </MenuItem>
                                    <MenuItem value="MASTER">
                                      Masterkat landing strana
                                    </MenuItem>
                                  </Select>
                                </FormControl>
                              </Col>
                            </Row>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col lg={12}>
                      <Card>
                        <Card.Header>
                          <FormTitleMain title="Prevodi" />
                        </Card.Header>
                        <Card.Body>
                          {/* Tabs header */}
                          <Tabs
                            value={activeLocaleTab}
                            onChange={handleChangeLocaleTab}
                            variant="scrollable"
                            // scrollButtons
                            // allowScrollButtonsMobile
                          >
                            {languagesItems.map((lng, idx) => (
                              <Tab
                                key={lng.code}
                                label={lng.label}
                                {...a11yProps(idx)}
                                // primer: pokaži zvezdicu ako fali naslov
                                iconPosition="end"
                              />
                            ))}
                          </Tabs>

                          {/* Tabs content */}
                          {languagesItems.map((lng, idx) => (
                            <TabPanel
                              key={lng.code}
                              value={activeLocaleTab}
                              index={idx}
                            >
                              <Row>
                                <input type="hidden" value={lng.id} name="id" />
                                <Col lg={12} className="mb-4">
                                  <InputField
                                    name={`title_${lng.code}`}
                                    label={`${t(`${translateForm}.title`)} `}
                                    value={locales[lng.code].title}
                                    size="small"
                                    onChange={(e) =>
                                      updateLocale(
                                        lng.code,
                                        "title",
                                        e.target.value
                                      )
                                    }
                                    error={errors?.locales?.[lng.code]?.title}
                                    errorsHandler={setErrors}
                                    // required
                                  />
                                </Col>
                                <Col lg={12} className="mb-3">
                                  <InputField
                                    name={`subtitle_${lng.code}`}
                                    label={`${t(`${translateForm}.subtitle`)} `}
                                    value={locales[lng.code].subtitle}
                                    size="small"
                                    onChange={(e) =>
                                      updateLocale(
                                        lng.code,
                                        "subtitle",
                                        e.target.value
                                      )
                                    }
                                    error={
                                      errors?.locales?.[lng.code]?.subtitle
                                    }
                                    errorsHandler={setErrors}
                                    // required
                                  />
                                </Col>
                                <Col lg={12} className="mb-3">
                                  <InputField
                                    name={`button${lng.code}`}
                                    label={`${t(`${translateForm}.button`)} `}
                                    value={locales[lng.code].button}
                                    size="small"
                                    onChange={(e) =>
                                      updateLocale(
                                        lng.code,
                                        "button",
                                        e.target.value
                                      )
                                    }
                                    error={errors?.locales?.[lng.code]?.button}
                                    errorsHandler={setErrors}
                                    // required
                                  />
                                </Col>

                                {/* <Col lg={12} className="mb-3">
                                  <InputField
                                    name={`description_${lng.code}`}
                                    label={`${t(
                                      `${translateForm}.description`
                                    )} `}
                                    value={locales[lng.code].description || ""}
                                    onChange={(e) =>
                                      updateLocale(
                                        lng.code,
                                        "description",
                                        e.target.value
                                      )
                                    }
                                    error={errors}
                                    errorsHandler={setErrors}
                                    fullWidth
                                    size="small"
                                    required
                                    multiline
                                    minRows={4} // ako tvoj InputField prosleđuje TextField, može i rows={4}
                                  />
                                </Col> */}
                              </Row>
                            </TabPanel>
                          ))}
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                </Col>
                <Col lg={3}>
                  <Row>
                    <Col lg={12}>
                      <Card>
                        <Card.Header>{t(`global.settings`)}</Card.Header>
                        <Card.Body>
                          <SelectStatus
                            active={true}
                            data={data}
                            handleInputChange={handleInputChange}
                          />
                        </Card.Body>
                      </Card>
                    </Col>
                    {/* <Col lg={12}>
                      <Card>
                        <Card.Header>Mobilna slika</Card.Header>
                        <Card.Body>
                          <UploadImage
                            name="mobileBanner"
                            label="Odaberite sliku"
                            value={files.mobileBanner}
                            onChange={setFile("mobileBanner")}
                            required
                          />
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col lg={12}>
                      <Card>
                        <Card.Header>Baner slika</Card.Header>
                        <Card.Body>
                          <UploadImage
                            name="banner"
                            label="Odaberite sliku"
                            value={files.banner}
                            onChange={setFile("banner")}
                            required
                          />
                        </Card.Body>
                      </Card>
                    </Col> */}
                  </Row>
                </Col>
              </Row>
            </form>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default SliderAdd;
